import Footer from './Footer';

export const Default = {
  component: Footer,
  props: {},
};
